<script setup>
import { inject } from 'vue'
import { useChatStore } from '@/stores/chat.js'
import { storeToRefs } from 'pinia'

const message = inject('message')
const close = inject('close')

const chatStore = useChatStore()

const {
  messageToReply
} = storeToRefs(chatStore)

function reply () {
  messageToReply.value = Object.assign({}, message)

  if (!message.text) {
    if (message.attachment) {
      messageToReply.value.text = '[Attachment]'
    } else if (message.post) {
      messageToReply.value.text = '[Post]'
    } else {
      messageToReply.value.text = '[Message]'
    }
  }

  close()
}
</script>

<template>
  <button
    role="menuitem"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left"
    @click="reply">
    <InlineSvg :src="require('@/assets/fontawesome/regular/reply.svg')" class="w-4 h-4 shrink-0"/>

    {{ $t('common.reply') }}
  </button>
</template>